/**
 *
 * Asynchronously loads the component for EventForm
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
